<div class="app-card shadow-2 surface-card">
  <div class="flex p-4 flex-row justify-content-between align-items-center">
    <div class="flex align-items-center">
      <p-avatar [icon]="icon" styleClass="app-avatar-primary" class="mr-3" size="xlarge" shape="circle"></p-avatar>
      <div>
        <div class="text-xl font-medium text-900 mb-2">{{ title }}</div>
        <div *ngIf="description" class="font-medium text-500 mb-0 text-sm">{{ description }}</div>
      </div>
    </div>
    <div class="flex align-items-center">
      <ng-content></ng-content>
    </div>
  </div>
  <ng-content select="[headerFooter]"></ng-content>
</div>
